export const generateOptionsFromMaxCount = (maxCount: number, startFrom = 0) => {
  const options: { label: string; value: number }[] = [];

  for (let i = startFrom; i <= maxCount; i++) {
    const optionItem = { label: i.toString(), value: i };
    options.push(optionItem);
  }

  return options;
};
